import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { TokenService } from '../auth/token.service';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const token = inject(TokenService).getAccessToken();
  const isApiRequest =
    request.url.startsWith(environment.identityApiBaseUrl) ||
    request.url.startsWith(environment.businessApiBaseUrl) ||
    request.url.startsWith(environment.marketplaceApiBaseUrl);

  if (!token || !isApiRequest) {
    return next(request);
  }

  return next(
    request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    }),
  );
};
